/**
 * @generated SignedSource<<96febfdf3a95e91ba93183212757be35>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type JobEventReservedExpired_event$data = {
  readonly timestamp: any;
  readonly " $fragmentType": "JobEventReservedExpired_event";
};
export type JobEventReservedExpired_event$key = {
  readonly " $data"?: JobEventReservedExpired_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"JobEventReservedExpired_event">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "JobEventReservedExpired_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timestamp",
      "storageKey": null
    }
  ],
  "type": "JobEvent",
  "abstractKey": "__isJobEvent"
};

(node as any).hash = "fa4ad5672531d84ee79df9b994267907";

export default node;
